import http from '../../Http-common';

const create = (data) => {
    return http.post('/authenticate', data);
}

const LoginService = {
    create,
}
export default LoginService;